module.exports = __webpack_public_path__ + "static/media/veneto-village-25.5492d365.jpg";